import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.instanceOf(Object)]).isRequired,
};

export default function CrmPageWrapper(props) {
  const {children} = props;
  return <div className="crm-wrapper">{children}</div>;
}

CrmPageWrapper.propTypes = propTypes;
